<template>
  <div class="selections-index row">
    <div class="selection col col-md-3 col-6"
      v-for="(item, index) in selected">
      <div class="selections-image">
        <img
          v-if="item.imagePath"
          :src="`/${item.imagePath}`">
      </div>
      <select
        v-model="selected[index]"
        v-if="isAuthorized('selections-edit', $route.params.id)">
        <option value="">Sorte wählen</option>
        <option
          v-for="cream in selectedOrUnassignedCreams(selected[index])"
          :value="cream">
          {{ cream.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import auth from '../../../services/auth'

export default {
  props: ['all', 'selected', 'ids'],

  methods: {
    selectedOrUnassignedCreams (selectedCream) {
      const result = this.all.filter(cream => {
        const isAssigned = this.ids.includes(cream.id)
        const isSelected = (cream.id === selectedCream.id)
        return (!isAssigned || isSelected)
      })
      return result
    },

    isAuthorized (action, restriction) {
      return auth.isAuthorized(action, restriction)
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../../../assets/styles/variables';

  .selection select {
    width: 200px;
  }

  .selections-image {
    margin: $spacer-y*2 0 $spacer-y;
    width: 200px;
    height: 225px;
    background-color: rgba($black, 0.02);
    overflow: hidden;

    > img {
      display: block;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// _index.vue?1c1d7541